import React, { memo } from 'react';
import TrainingVideosListItem from "./TrainingVideosListItem";
import '../../Styles/FAQ.css'
import { Row } from 'react-bootstrap';

/**
 * FAQVideosList renders the videos at FAQ Page.
 * @param videoData
 * @returns {JSX.Element}
 * @constructor
 */
const TrainingVideosList = ({ videoData }) => {

    return (
        <Row style={{
            display:'flex',
            // background:'green',
            alignItems:'center',
            // justifyContent:'center'
        }}>
            {videoData.map(video => <TrainingVideosListItem key={video.name} videoData={video} />)}
        </Row>

    )

}

export default memo(TrainingVideosList);
